export const updatePhoneSelectionInCart = (selectedPhoneService) => ({
    type: 'UPDATE_SELECTED_PHONE_SERVICE_IN_CART',
    data: selectedPhoneService
});

export const updateNLinesInCart = (lines) => ({
    type: 'UPDATE_N_LINES_IN_CART',
    data: lines
});

export const updateFaxLineForBDVInCart = (faxLineInfo) => ({
    type: 'UPDATE_BDV_FAXLINE_IN_CART',
    data: faxLineInfo
});

export const updateDirectoryListingInCart = (listingInfo) => ({
    type: 'UPDATE_DIRECTORY_LISTING_IN_CART',
    data: listingInfo
});

export const UpdateEquipmentsInCart = (equipments) => ({
    type: 'UPDATE_EQUIPMENTS_IN_CART',
    data: equipments
});

export const updateTvPlanInCart = (tvPlan) => ({
    type: 'UPDATE_TV_PLAN_IN_CART',
    data: tvPlan
});

export const updatePremChannelsInCart = (premChannels) => ({
    type: 'UPDATE_PREMIUM_CHANNELS_IN_CART',
    data: premChannels
});

export const updateTvEquipInCart = (tvEquip) => ({
    type: 'UPDATE_TV_EQUIPMENT_IN_CART',
    data: tvEquip
});

export const updateTvRecordingInCart = (tvRec) => ({
    type: 'UPDATE_TV_RECORDING_IN_CART',
    data: tvRec
});

export const loadFloatingCart = () => ({
    type: 'LOAD_FLOATING_CART'
})

export const updateInternetSectionSubTotal = (price) => ({
    type: 'UPDATE_INTERNET_SECTION_SUB_TOTAL',
    data: price
})

export const updatePhoneSectionSubTotal = (price) => ({
    type: 'UPDATE_PHONE_SECTION_SUB_TOTAL',
    data: price
});

export const updateTvSectionSubTotal = (price) => ({
    type: 'UPDATE_TV_SECTION_SUB_TOTAL',
    data: price
});

export const updateOneTimeChargesSectionSubTotal = (price) => ({
    type: 'UPDATE_ONE_TIME_CHARGES_SECTION_SUB_TOTAL',
    data: price
});

export const updateInternetPlanInCart = (plan) => ({
    type: 'UPDATE_INTERNET_PLAN_IN_CART',
    data: plan
});

export const updateInternetIPInCart = (plan) => ({
    type: 'UPDATE_INTERNET_IP_IN_CART',
    data: plan
});

export const updatePhoneSelection = (data) => ({
    type: "UPDATE_PHONE_TYPE_SELECTION",
    data
})

export const updateNLines = (data) => ({
    type: "UPDATE_PHONE_LINES",
    data
})

export const updateFaxLines = (data) => ({
    type: "UPDATE_FAX_LINES",
    data
})

export const updateDirListingFcart = (data) => ({
    type: "UPDATE_DIR_LISTING_FCART",
    data
})

export const resetCartSelection = (data) => ({
    type: "RESET_CART_SELECTION",
    data
})